import styled from 'styled-components'

import { COLORS } from '../../DataGrid.theme'

export const Root = styled.div<{ alwaysVisible?: boolean }>`
  display: ${p => (p.alwaysVisible ? 'flex' : 'none')};
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  margin-right: 2px;
  margin-left: 4px;
  justify-content: space-between;
  gap: 6px;
  height: 100%;

  &:hover {
    color: ${COLORS.neutralExtremelyDark};
    svg {
      color: ${COLORS.neutralExtremelyDark};
    }
  }
`

export const IndicatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 24px;
`

export const IconWrapper = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 10px;
    height: 6px;
    min-width: 10px;
    max-width: 10px;
    min-height: 6px;
    max-height: 6px;
    flex-shrink: 0;
    box-sizing: content-box;
    display: block;
    color: ${({ active }) => (active ? `${COLORS.black} !important` : COLORS.neutralDark)};
  }
`
